import {
  CardId,
  TCardLayoutSlot,
  TCardPosition,
  TCardSlotPosition,
  TCard,
} from '@/console/features/card-layout/card-layout.types';

export const recalculatePositions = (cards: TCard[]): TCard[] => {
  const pipelineCard = cards.find((card) => card.id === CardId.PIPELINES);
  const regularCards = cards.filter((card) => card.id !== CardId.PIPELINES);

  if (cards.length === 1) {
    return [
      {
        ...cards[0],
        position: {
          slot: TCardLayoutSlot.TOP,
          order: TCardSlotPosition.FILL,
        },
      },
    ];
  }

  if (pipelineCard) {
    return [
      {
        ...pipelineCard,
        position: {
          slot: TCardLayoutSlot.BOTTOM,
          order: TCardSlotPosition.FILL,
        },
      },
      ...assignRegularCardPositions(regularCards, true),
    ];
  }

  return assignRegularCardPositions(cards, false);
};

const assignRegularCardPositions = (
  cards: TCard[],
  hasPipeline: boolean = false,
): TCard[] => {
  let positions: TCardPosition[];

  if (hasPipeline) {
    positions = [
      { slot: TCardLayoutSlot.TOP, order: TCardSlotPosition.FIRST },
      { slot: TCardLayoutSlot.RIGHT, order: TCardSlotPosition.FIRST },
      { slot: TCardLayoutSlot.TOP, order: TCardSlotPosition.SECOND },
      { slot: TCardLayoutSlot.RIGHT, order: TCardSlotPosition.SECOND },
    ];
  } else {
    positions = [
      { slot: TCardLayoutSlot.TOP, order: TCardSlotPosition.FIRST },
      { slot: TCardLayoutSlot.BOTTOM, order: TCardSlotPosition.FIRST },
      { slot: TCardLayoutSlot.RIGHT, order: TCardSlotPosition.FIRST },
      { slot: TCardLayoutSlot.BOTTOM, order: TCardSlotPosition.SECOND },
      { slot: TCardLayoutSlot.RIGHT, order: TCardSlotPosition.SECOND },
    ];
  }

  return cards.map((card, index) => ({
    ...card,
    position:
      index < positions.length
        ? positions[index]
        : positions[positions.length - 1],
  }));
};

export const createNewCard = (
  cardId: CardId,
  existingCards: TCard[],
): TCard | null => {
  const newCards = [
    ...existingCards,
    {
      id: cardId,
      position: { slot: TCardLayoutSlot.TOP, order: TCardSlotPosition.FIRST },
    },
  ];

  if (newCards.length > 5 && cardId !== CardId.PIPELINES) {
    return null;
  }

  const recalculatedCards = recalculatePositions(newCards);
  return recalculatedCards.find((card) => card.id === cardId) || null;
};
